import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUploadPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 12.75V18c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2v-5.25M12 4v11.25M7.5 8.5 12 4l4.5 4.5"
    />
  </svg>
);
export default SvgUploadPdf;
